import { trans } from "@mongez/localization";
import { Button } from "~/design-system/components";
import { useCookieConsent } from "../hooks";
import { cookiePreferencesPortal } from "./CookiePreferencesPortal";

export interface CookieConsent {
  essential: boolean;
  analytics: boolean;
  functional: boolean;
  marketing: boolean;
}

export function CookieConsentBanner() {
  const { handleRejectNonEssential, handleAcceptAll, showBanner } =
    useCookieConsent();

  const handleManagePreferences = () => {
    cookiePreferencesPortal.open();
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="border-primary-default fixed right-0 bottom-0 left-0 z-100 border-t-2 bg-white shadow-2xl backdrop-blur-sm">
      <div className="container mx-auto px-4 py-4 sm:py-6">
        <div className="flex flex-col gap-4 sm:gap-6 lg:flex-row lg:items-center lg:justify-between lg:gap-8">
          <div className="flex-1">
            <div className="flex items-center gap-3 sm:gap-4">
              <div className="from-primary-default to-primary-600 ring-primary-default ring-opacity-20 flex size-10 shrink-0 items-center justify-center rounded-full bg-linear-to-br shadow-lg ring-2 sm:size-12">
                <svg
                  className="size-5 text-white sm:size-7"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                </svg>
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="font-playfair text-primary mb-1 text-lg leading-tight font-bold sm:mb-2 sm:text-xl lg:text-2xl">
                  {trans("cookieBanner.title") || "We Value Your Privacy"}
                </h3>
                <p className="text-sm leading-relaxed text-gray-600 sm:text-base">
                  {trans("cookieBanner.description") ||
                    "We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. By clicking 'Accept All', you consent to our use of cookies."}
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-2 sm:gap-3 lg:shrink-0 lg:flex-row">
            <Button
              onClick={handleRejectNonEssential}
              className="justify-center rounded-full border border-gray-300 bg-white px-4 py-2.5 text-center text-xs font-medium text-gray-700 transition-all duration-200 hover:border-gray-400 hover:bg-gray-50 hover:shadow-md sm:px-6 sm:py-3 sm:text-sm"
            >
              {trans("cookieBanner.rejectNonEssential") ||
                "Reject Non-Essential"}
            </Button>
            <Button
              onClick={handleManagePreferences}
              className="border-primary-default text-primary-default hover:bg-primary-default justify-center rounded-full border bg-white px-4 py-2.5 text-center text-xs font-medium transition-all duration-200 hover:text-white hover:shadow-md sm:px-6 sm:py-3 sm:text-sm"
            >
              {trans("cookieBanner.managePreferences") || "Manage Preferences"}
            </Button>
            <Button
              onClick={handleAcceptAll}
              className="bg-primary-default hover:bg-primary-600 justify-center rounded-full px-6 py-2.5 text-center text-xs font-medium text-white transition-all duration-200 hover:scale-105 hover:shadow-lg sm:px-8 sm:py-3 sm:text-sm"
            >
              {trans("cookieBanner.acceptAll") || "Accept All"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
